import React, {useEffect, useState} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {useIntl} from 'react-intl'
import {Button, Col, Form, Row} from 'react-bootstrap'
import axios from 'axios'
import {toast} from 'react-toastify'

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: '',
    path: '',
    isSeparator: false,
    isActive: false,
  },
]

const LinkConfigPage = () => {
  const [linkTextOne, setLinkTextOne] = useState('')
  const [linkUrlOne, setLinkUrlOne] = useState('')

  const [linkTextTwo, setLinkTextTwo] = useState('')
  const [linkUrlTwo, setLinkUrlTwo] = useState('')

  const [linkTextThree, setLinkTextThree] = useState('')
  const [linkUrlThree, setLinkUrlThree] = useState('')

  useEffect(() => {
    const getLinkConfig = async () => {
      const linkConfig = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASEURL}/general-settings/getConfigById/`,
        {
          id: '1',
        }
      )
      if (linkConfig.data?.status == 'SUCCESS') {
        let navLinks = JSON.parse(linkConfig.data.data[0].settings)
        setLinkTextOne(navLinks[0].linkTextOne)
        setLinkUrlOne(navLinks[0].linkUrlOne)
        setLinkTextTwo(navLinks[1].linkTextTwo)
        setLinkUrlTwo(navLinks[1].linkUrlTwo)
        setLinkTextThree(navLinks[2].linkTextThree)
        setLinkUrlThree(navLinks[2].linkUrlThree)
      }
    }
    getLinkConfig()
  }, [])

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    let payLoad = {
      settings: [
        {linkTextOne: linkTextOne, linkUrlOne: linkUrlOne},
        {linkTextTwo: linkTextTwo, linkUrlTwo: linkUrlTwo},
        {linkTextThree: linkTextThree, linkUrlThree: linkUrlThree},
      ],
      gen_id: '1',
    }

    const linkConfig = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASEURL}/general-settings/updateSettings/`,
      payLoad
    )
    if (linkConfig.data?.status == 'SUCCESS') {
      toast.success('Configurations Updated successfully', {
        position: 'bottom-right',
        theme: 'dark',
      })
    }
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className='card p-5 mb-3'>
          {/* <div className='regionHeadingDiv'>
            <h3 className='regionNameHeading'>Region Name</h3>

          </div> */}
          <Row className='mb-5'>
            <Col>
              <Form.Group controlId={`title-${'index'}`}>
                <Form.Label className='ms-3'>Title</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Enter title'
                  value={'Link 1'}
                  // onChange={(e) => handleInputChange(index, 'title', e.target.value)}
                  style={{border: 'none', color: 'black', fontWeight: '700'}}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group controlId={`subtitle1-${'index'}`}>
                <Form.Label>Link Text</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Link Text'
                  value={linkTextOne}
                  onChange={(e) => setLinkTextOne(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group controlId={`subtitle2-${'index'}`}>
                <Form.Label>Navigation Url</Form.Label>
                <Form.Control
                  type='text'
                  placeholder='Navigation Url'
                  value={linkUrlOne}
                  onChange={(e) => setLinkUrlOne(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-5 mt-4'>
            <Col>
              <Form.Group controlId={`title-${'index'}`}>
                {/* <Form.Label>Title</Form.Label> */}
                <Form.Control
                  type='text'
                  placeholder='Enter title'
                  value={'Link 2'}
                  style={{border: 'none', color: 'black', fontWeight: '700'}}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group controlId={`subtitle1-${'index'}`}>
                {/* <Form.Label>Link Text</Form.Label> */}
                <Form.Control
                  type='text'
                  placeholder='Link Text'
                  value={linkTextTwo}
                  onChange={(e) => setLinkTextTwo(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group controlId={`subtitle2-${'index'}`}>
                {/* <Form.Label>Navigation Url</Form.Label> */}
                <Form.Control
                  type='text'
                  placeholder='Navigation Url'
                  value={linkUrlTwo}
                  onChange={(e) => setLinkUrlTwo(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className='mb-5 mt-4'>
            <Col>
              <Form.Group controlId={`title-${'index'}`}>
                {/* <Form.Label>Title</Form.Label> */}
                <Form.Control
                  type='text'
                  placeholder='Enter title'
                  value={'Link 3'}
                  style={{border: 'none', color: 'black', fontWeight: '700'}}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group controlId={`subtitle1-${'index'}`}>
                {/* <Form.Label>Link Text</Form.Label> */}
                <Form.Control
                  type='text'
                  placeholder='Link Text'
                  value={linkTextThree}
                  onChange={(e) => setLinkTextThree(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group controlId={`subtitle2-${'index'}`}>
                {/* <Form.Label>Navigation Url</Form.Label> */}
                <Form.Control
                  type='text'
                  placeholder='Navigation Url'
                  value={linkUrlThree}
                  onChange={(e) => setLinkUrlThree(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <div>
            <Button className='linkFormSubBtn' variant='success' type='submit'>
              Submit
            </Button>
          </div>
        </div>
      </Form>
    </>
  )
}

const LinkConfigWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={dashboardBreadCrumbs}>
        {intl.formatMessage({id: 'Link Configurations'})}
      </PageTitle>
      <LinkConfigPage />
    </>
  )
}

export default LinkConfigWrapper
